import { fabric } from "fabric";
import { STROKE_WIDTH } from "components/ZoomableImage";
import _ from "lodash";

export const setBboxColor = (selectedMarker) => {
    if (selectedMarker) {
        if (selectedMarker.class === "Troughing") {
            const autoClassification = _.get(selectedMarker, "classifications.troughing_condition.auto", null);
            const userClassification = _.get(selectedMarker, "classifications.troughing_condition.user", null);

            if (!userClassification) {
                if (autoClassification === "good") {
                    return "#47C66B";
                }
                if (autoClassification === "defect") {
                    return "red";
                }
                if (autoClassification === "invalid" || autoClassification === "no_result" || !autoClassification) {
                    return "white";
                }
            } else {
                if (userClassification === "good") {
                    return "#47C66B";
                }
                if (userClassification === "defect") {
                    return "red";
                }
                if (userClassification === "invalid") {
                    return "white";
                }
            }

            return "yellow";
        } else if (selectedMarker.display_name === "Low Ballast") {
            return "red";
        }
    }
    return "#47C66B";
};

export const getColorFromPercentage = (percentage, alpha = 1, maxPerc = 20) => {
    const interpolated_value = Math.min(percentage, maxPerc) / maxPerc;

    const green = Math.round(255 * (1 - interpolated_value));

    const red = 255;
    const blue = 0;

    const rgbColor = `rgba(${red}, ${green}, ${blue}, ${alpha})`;

    return rgbColor;
};

export const generateZoomableImageBbox = (bbox, ratioChange, strokeColor) => {
    const [left, top, width, height] = bbox;
    const box = new fabric.Rect({
        left: left * ratioChange,
        top: top * ratioChange,
        width: width * ratioChange,
        height: height * ratioChange,
        fill: "transparent",
        strokeWidth: STROKE_WIDTH,
        centeredScaling: false,
        stroke: strokeColor,
        controls: {
            ...fabric.Text.prototype.controls,
            mtr: new fabric.Control({ visible: false }),
        },
        selectable: false,
        hoverCursor: "all-scroll",
        strokeUniform: true,
    });

    return box;
};

export const generateZoomableImageBboxLabel = (bbox, ratioChange, label, strokeColor, newHeight, newWidth, alpha = 1) => {
    let [left, top, width, height] = bbox;

    const isLeftHalf = (left + width) / 2 < newWidth / 2;
    let centerX = (left + width) * ratioChange;
    if (!isLeftHalf) {
        centerX = left * ratioChange;
    }

    const inTopHalf = top * ratioChange + (height * ratioChange) / 2 < newHeight / 2;
    const textTop = inTopHalf ? (top + height) * ratioChange + 10 : top * ratioChange - 20;

    const textBox = new fabric.Text(label, {
        left: centerX,
        top: textTop,
        originX: "center",
        fontSize: 13,
        fontFamily: "Helvetica",
        fontWeight: 500,
        fill: strokeColor,
        textBackgroundColor: `rgba(0, 0, 0, ${alpha})`,
    });

    return textBox;
};

export const generateZoneGrids = (gridRows, gridCols, bbox, canvas, percentage, activeCellGroup, cellStates, margin = 0) => {
    const bboxX = bbox.left;
    const bboxY = bbox.top;
    const bboxWidth = bbox.width;
    const bboxHeight = bbox.height;

    const totalWidth = bboxWidth - (gridCols - 1) * margin;
    const totalHeight = bboxHeight - (gridRows - 1) * margin;
    const cellWidth = totalWidth / gridCols;
    const cellHeight = totalHeight / gridRows;

    for (let row = 0; row < gridRows; row++) {
        for (let col = 0; col < gridCols; col++) {
            const cellIndex = row * gridCols + col;
            const activeCellColor = getColorFromPercentage(percentage, 0.3);
            // This code is drawing the inactive cells, turned off for now until a decision is made about whether we want this.
            // const inactiveCellColor = "rgba(255, 255, 255, 0.09)";

            // Draw the main zone grid first. This grid includes all the cells that comprise the zone.
            // const mainZoneCellRect = new fabric.Rect({
            //     left: bboxX + col * (cellWidth + margin),
            //     top: bboxY + row * (cellHeight + margin),
            //     width: cellWidth,
            //     height: cellHeight,
            //     fill: inactiveCellColor,
            //     stroke: "transparent",
            //     strokeWidth: 1,
            //     selectable: false,
            // });
            // mainCells.push(mainZoneCellRect);

            // Then draw the encroachment grid. This grid includes only the cells that are encroaching, and will be clipped using the
            // encroachment bbox in the calling code.
            const encroachmentRect = new fabric.Rect({
                left: bboxX + col * (cellWidth + margin),
                top: bboxY + row * (cellHeight + margin),
                width: cellWidth,
                height: cellHeight,
                fill: cellStates[cellIndex] === 1 ? activeCellColor : "transparent",
                stroke: "transparent",
                strokeWidth: 1,
                selectable: false,
            });

            // Only add cell to the cell group if it is active
            if (cellStates[cellIndex] === 1) {
                activeCellGroup.addWithUpdate(encroachmentRect);
            }
        }
    }
};
